import { errorMsg } from '../constants/messages';
const SignedUpUsersFormData = [
  {
    title: 'User Information',
    name: 'id',
    label: 'User ID',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'User ID',
      enableSort: false,
      allowAddRecordClick: true,
      columnType: 'text',
      render: (record: any) => record.id || record._id || 'N/A',
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    hideFromUserFormGrid: true,
    useSidebarLayoutInAccordion: true,
    useReadonlyCard: true,
    sidebarField: true,
    readonly: true,
  },
  {
    name: 'name',
    label: 'User Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'User Name',
      enableSort: false,
      allowAddRecordClick: true,
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    sidebarField: true,
  },
  {
    name: 'phone',
    label: 'Phone',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Phone' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    sidebarField: true,
  },
  {
    name: 'email',
    label: 'Email',
    fieldType: {
      name: 'email',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Email' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    sidebarField: true,
  },
  {
    name: 'createdAt',
    label: 'Registration Date',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Registration Date',
      enableSort: true,
      columnType: 'registrationDate',
      render: (record: any) => {
        if (!record.createdAt) return '';
        return record.createdAt;
      },
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    readonly: true,
    forceGridRowStart: true,
  },


  // {
  //   name: 'sendReminder',
  //   label: 'Reminder',
  //   fieldType: {
  //     name: 'text',
  //   },
  //   required: false,
  //   readonly: true,
  //   errorMsg: errorMsg,
  //   tableMeta: {
  //     title: 'Reminder',
  //     enableSort: false,
  //     allowAddRecordClick: false,
  //     columnType: 'sendReminder',
  //   },
  //   isTableHeader: true,
  //   isAccordian: false,
  //   default: '',
  //   hideFromUserFormGrid: true,
  // },

  {
    name: 'active',
    label: 'Active',
    fieldType: {
      name: 'radio',
      options: [
        { label: 'Active', value: 'Active' },
        { label: 'Inactive', value: 'Inactive' },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'active',
      columnType: 'checkbox',
      allowAddRecordClick: false,
      render: (record: any) => ({
        value: record.active === true || record.active === 'true' || record.active === 'Active',
        record: record,
      }),
    },
    isTableHeader: true,
    isAccordian: true,
    default: 'Active',
  },
  {
    name: 'isVerified',
    label: 'Verified',
    fieldType: {
      name: 'radio',
      options: [
        { label: 'Verified', value: 'Verified' },
        { label: 'Unverified', value: 'Unverified' },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'isVerified',
      columnType: 'isVerified',
    },
    isTableHeader: true,
    isAccordian: true,
    default: 'Verified',
  },
  {
    name: 'partnerId',
    label: 'Referral Partner ID',
    fieldType: {
      name: 'text',
    },
    required: false,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Referral Partner ID',
      allowAddRecordClick: false,
      columnType: 'lastReferralPartnerIdSeries',
    },
    isTableHeader: true,
    // Also show in signed-up user details view.
    isAccordian: true,

    default: '',
  },
  {
    name: 'referredByPartnerName',
    label: 'Refferred By Partner Name',
    fieldType: {
      name: 'text',
    },
    required: false,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Refferred By Partner Name',
      allowAddRecordClick: false,
      columnType: 'text',
      render: (record: any) => {
        return (
          record?.referredByPartnerName ||
          record?.referredByPartner?.name ||
          record?.referredByPartner?.partnerName ||
          record?.affiliate?.name ||
          '--'
        );
      },
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'orderActivityLabel',
    label: 'Order Activity',
    fieldType: {
      name: 'text',
    },
    required: false,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Order Activity',
      allowAddRecordClick: false,
      columnType: 'orderActivity',
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    hideFromUserFormGrid: true,
  },
];

export { SignedUpUsersFormData };
